/**
 * Revision route client
 */

import { get, post } from '../redux/api';
import { nuc } from '../utils';
import type { CreateRevisionLicenseResponse, GetRevisionLicensesResponse } from '../../shared/licenses/response';
import type { ListRevisionDeepLicensesResponse, ListRevisionDeepTodosResponse } from '../../typings/api';
import type { RevisionLicense } from '../../typings/common';

export const getRevisionDeepLicenses = async (locator: string) => {
  const resp = await get<ListRevisionDeepLicensesResponse>(`/api/revisions/${nuc(locator)}/deeplicenses`);

  return resp?.data;
};

export const getRevisionDeepTodos = async (locator: string, counts?: boolean) => {
  const resp = await get<ListRevisionDeepTodosResponse>(
    `/api/revisions/${nuc(locator)}/todos`,
    false,
    counts ? { counts: true } : undefined,
  );

  return resp?.data;
};

export const getRevisionLicenses = async (locator: string) => {
  const resp = await get<GetRevisionLicensesResponse>(`/api/revisions/${nuc(locator)}/licenses`);

  return resp?.data;
};

export const createRevisionLicense = (locator: string, body: RevisionLicense) => {
  return post<RevisionLicense, CreateRevisionLicenseResponse>(
    `/api/revisions/${nuc(locator)}/licenses`,
    body,
  );
};
